// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PaymentList{padding-bottom:12px}.PaymentList.shorten.has-selected .CardItem:not(.is-active){display:none}", ""]);
// Exports
module.exports = exports;
